"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBulkBusinessEnableBodyToJSON = exports.UpdateBulkBusinessEnableBodyFromJSONTyped = exports.UpdateBulkBusinessEnableBodyFromJSON = void 0;
var _1 = require("./");
function UpdateBulkBusinessEnableBodyFromJSON(json) {
    return UpdateBulkBusinessEnableBodyFromJSONTyped(json, false);
}
exports.UpdateBulkBusinessEnableBodyFromJSON = UpdateBulkBusinessEnableBodyFromJSON;
function UpdateBulkBusinessEnableBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'businesses': (json['businesses'].map(_1.BusinessFromJSON)),
        'isEnabled': json['isEnabled'],
    };
}
exports.UpdateBulkBusinessEnableBodyFromJSONTyped = UpdateBulkBusinessEnableBodyFromJSONTyped;
function UpdateBulkBusinessEnableBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'businesses': (value.businesses.map(_1.BusinessToJSON)),
        'isEnabled': value.isEnabled,
    };
}
exports.UpdateBulkBusinessEnableBodyToJSON = UpdateBulkBusinessEnableBodyToJSON;
